<template>
  <div class="forum-next-votes">
    <div role="group" aria-label="Valorar mensaje" :aria-busy="state.pending ? 'true' : 'false'">
      <button v-for="choice in choices" :key="choice.value" type="button" :aria-label="(votes.own === choice.value ? 'Quitar voto ' : 'Votar ') + choice.label" :aria-pressed="votes.own === choice.value ? 'true' : 'false'" :disabled="state.pending || !!state.error" @click="$emit('vote', votes.own === choice.value ? null : choice.value)">
        <i :class="choice.icon" aria-hidden="true"></i><span>{{ number(votes[choice.count]) }}</span>
      </button>
    </div>
    <p v-if="state.error" class="forum-next-reaction-error" role="alert">{{ state.error.message }} <button type="button" @click="$emit('refresh')">Comprobar estado</button></p>
    <span v-else class="forum-next-sr" role="status">{{ state.pending ? 'Guardando voto…' : state.done ? 'Voto actualizado.' : '' }}</span>
  </div>
</template>
<script>
export default {
  name: 'ForumVotes', props: { votes: { type: Object, required: true }, state: { type: Object, default: () => ({}) } },
  data: () => ({ choices: [{ value: 1, label: 'positivo', icon: 'pi pi-thumbs-up', count: 'positive' }, { value: -1, label: 'negativo', icon: 'pi pi-thumbs-down', count: 'negative' }] }),
  methods: { number(value) { return value === null ? '—' : new Intl.NumberFormat('es-ES').format(value); } }
};
</script>
